import React from 'react';
import type PlanRoadmapType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-report/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Report page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanReport = lazyForPaint<typeof PlanRoadmapType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-report", jiraSpaEntry: "async-plan-report" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-report'
			),
		),
	{ ssr: false },
);

const PlanReport = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanReport} pageId="plan-report" shouldShowSpinner />
);

export default PlanReport;
